import React from 'react'
import ChangelogInstance from '../ChangelogInstance';

const TwoDotSixDotOne = () => {
  return (
    <ChangelogInstance version="2.6.1" date="2020-07-03">
      <li>
        Fixed a bug that made market listings disappear.
      </li>

    </ChangelogInstance>
  );
}

export default TwoDotSixDotOne;